module.exports = __webpack_public_path__ + "static/media/7.3b4a6783.jpg";